/* eslint-disable array-callback-return */
import { useCallback, useEffect, useRef, useState } from 'react';
import {
  Container,
  Sidebar,
  MainContent,
  SidebarTitulo,
  Button,
  Titulo,
  Paragrafo,
  StyledCodeEditor,
  SidebarContainer,
} from './styles';
import Drawer from '@mui/material/Drawer';
import Core from '../Core';
import useWindowSize from '../../hooks/useWindowSize';
import { useAuth } from '../../hooks/useAuth';
import { toast } from 'react-toastify';
import { UserProps } from '../User/types';
import * as api from '../../services/api';
import { browserItens } from './BrowserItens';

const consultaMarcaModeloAnoItems = [
  { label: 'Requisição de Listagem de Marcas', step: 3 },
  { label: 'Requisição de Listagem de Modelos por Marca', step: 4 },
  { label: 'Requisição de listagem de Anos', step: 5 },
  { label: 'Consulta Final', step: 6 },
];

const consultaHashItems = [
  { label: 'Consulta por Hash', step: 9 },
];
const consultaMonthsYearsItems = [
{ label: 'Requisição de Listagem de Mês/Ano de referência', step: 2 }
];

const consultaSomosItems = [
  { label: 'Listagem de Anos Modelos por Código Somos', step: 10 },
  { label: 'Consulta Final por Código Somos', step: 11 },
];
const consultaLeves0kmItems = [
  { label: 'Requisição de Listagem de Marcas', step: 12 },
  { label: 'Requisição de Listagem de Modelos por Marca', step: 13 },
  { label: 'Consulta Final', step: 14 },
];

export function Doc() {
  const textRef = useRef(null);
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [openDrawer, setOpenDrawer] = useState(false);
  const { width } = useWindowSize();
  const isMobile = width < 786;
  const { user } = useAuth();
  const [userData, setUserData] = useState<UserProps>();

  const toggleDrawer = (open: any) => (event: any) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Escape')
    ) {
      setOpenDrawer(false);
    }
    setOpenDrawer(open);
  };

  const handleItemClick = (index: number) => {
    setActiveItemIndex(index);
    if (isMobile) {
      setOpenDrawer(true);
    }
  };

  const getUserData = useCallback(async () => {
    await api
      .get(`user/retrieve/${user?.id}/`)
      .then((response: any) => {
        setUserData(response.data.content);
      })
      .catch((error: any) => {
        toast.error(error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, [user]);

  useEffect(() => {
    getUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const consultaPlacaChassiItems = [
    ...(userData?.can_query_chassi_or_plate
      ? [{ label: 'Consulta Final de Semirreboque', step: 7 }]
      : []),
    ...(userData?.can_query_chassi_or_plate_bus_truck
      ? [{ label: 'Consulta Final de Caminhões e Ônibus', step: 8 }]
      : []),
  ];

  return (
    <Core withBlueBar withNavbar>
      <Container>
        <Sidebar
          style={{
            width: isMobile ? '100%' : '320px',
            height: isMobile ? '100%' : '',
          }}
        >
          <SidebarTitulo>Autenticação token</SidebarTitulo>
          <SidebarContainer>
            <ul>
              <li
                className={activeItemIndex === 0 ? 'active' : ''}
                onClick={() => handleItemClick(0)}
                style={{ marginTop: '0' }}
              >
                Adquirir token
              </li>
            </ul>
          </SidebarContainer>
          <SidebarTitulo>Listagem de Mês/Ano de referência</SidebarTitulo>
          <SidebarContainer>
            <ul>
              {consultaMonthsYearsItems.map((item, index) => (
                <li
                  key={index}
                  className={activeItemIndex === item.step - 1 ? 'active' : ''}
                  onClick={() => handleItemClick(item.step - 1)}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </SidebarContainer>
          {(userData?.can_query_chassi_or_plate ||
            userData?.can_query_chassi_or_plate_bus_truck) && (
              <>
                <SidebarTitulo>Consulta por Chassi e Placa</SidebarTitulo>
                <SidebarContainer>
                  <ul>
                    {consultaPlacaChassiItems.map((item, index) => (
                      <li
                        style={{ marginTop: index === 0 ? '0' : '' }}
                        className={
                          activeItemIndex === item.step - 1 ? 'active' : ''
                        }
                        key={index}
                        onClick={() => handleItemClick(item.step - 1)}
                      >
                        {item.label}
                      </li>
                    ))}
                  </ul>
                </SidebarContainer>
              </>
            )}
          <SidebarTitulo>Consulta por Leves (0km)</SidebarTitulo>
          <SidebarContainer>
            <ul>
              {consultaLeves0kmItems.map((item, index) => (
                <li
                  key={index}
                  className={activeItemIndex === item.step - 1 ? 'active' : ''}
                  onClick={() => handleItemClick(item.step - 1)}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </SidebarContainer>
          <SidebarTitulo>Consulta por Hash</SidebarTitulo>
          <SidebarContainer>
            <ul>
              {consultaHashItems.map((item, index) => (
                <li
                  key={index}
                  className={activeItemIndex === item.step - 1 ? 'active' : ''}
                  onClick={() => handleItemClick(item.step - 1)}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </SidebarContainer>
          <SidebarTitulo>Consulta por Cod Somos</SidebarTitulo>
          <SidebarContainer>
            <ul>
              {consultaSomosItems.map((item, index) => (
                <li
                  key={index}
                  className={activeItemIndex === item.step - 1 ? 'active' : ''}
                  onClick={() => handleItemClick(item.step - 1)}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </SidebarContainer>

          <SidebarTitulo>Consulta por Marca / Modelo / Ano</SidebarTitulo>
          <div
            style={{ height: '20rem', padding: '1rem', marginBottom: '1rem' }}
          >
            <ul>
              {consultaMarcaModeloAnoItems.map((item, index) => (
                <li
                  style={{ marginTop: index === 0 ? '0' : '' }}
                  className={activeItemIndex === item.step - 1 ? 'active' : ''}
                  key={index}
                  onClick={() => handleItemClick(item.step - 1)}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
        </Sidebar>
        {isMobile ? (
          <Drawer
            anchor={'bottom'}
            open={openDrawer}
            onClose={toggleDrawer(false)}
          >
            <Button onClick={toggleDrawer(false)}>&times;</Button>
            <div style={{ padding: '16px', width: '100%', marginTop: '3rem' }}>
              <Titulo>{browserItens[activeItemIndex].name}</Titulo>
<Paragrafo dangerouslySetInnerHTML={{ __html: browserItens[activeItemIndex].text }} />
              <StyledCodeEditor
                value={browserItens[activeItemIndex].code}
                ref={textRef}
                language="javascript"
                placeholder="Código de integração"
                padding={15}
                readOnly
              />
            </div>
          </Drawer>
        ) : (
          <MainContent>
            <div style={{ width: isMobile ? '100%' : '80%' }}>
              <Titulo>{browserItens[activeItemIndex].name}</Titulo>
<Paragrafo dangerouslySetInnerHTML={{ __html: browserItens[activeItemIndex].text }} />
              <StyledCodeEditor
                value={browserItens[activeItemIndex].code}
                ref={textRef}
                language="javascript"
                placeholder="Código de integração"
                padding={15}
                readOnly
              />
            </div>
          </MainContent>
        )}
      </Container>
    </Core>
  );
}